import ShopItem from "./shop-item";

class Shop {
  cart = [];
  currency = "CHF";
  total = 0;
  th = ["Menge", "Artikel", "Richtpreis"];
  constructor($el) {
    this.$el = $el;
    this.$items = $el.find('[data-shop="item"]');
    this.$totalAmount = $el.find('[data-shop="total-amount"]');
    this.$summaryTable = $el.find('[data-shop="summary-table"]');
    this.$nextButton = $el.find('[data-shop="next-button"]');
    this.$prevButton = $el.find('[data-shop="prev-button"]');
    this.$step1 = $el.find('[data-shop="step1"]');
    this.$step2 = $el.find('[data-shop="step2"]');
    this.$form = $el.find('[data-shop="form"]');
    this.$formSubmit = $el.find('[data-shop="form-submit"]');
    this.$formContainer = $el.find('[data-shop="form-container"]');
    this.$orderField = $el.find('[data-shop="order-field"]');
    this.$amountField = $el.find('[data-shop="amount-field"]');

    console.log("initted");

    this.init();
  }

  init = () => {
    this.$items.each((i, el) => {
      const item = new ShopItem($(el));
    });

    this.$items.on("update-item", this.updateCartHandler);
    this.$nextButton.on("click", this.nextStepHandler);
    this.$prevButton.on("click", this.prevStepHandler);
    this.$form.on("submit", this.formSubmitHandler);
  };

  updateCartHandler = (e, item) => {
    if (item.amount > 0) {
      // add bzw replace cart item
      const index = this.cart.findIndex((obj) => obj.id === item.id);

      if (index === -1) {
        // add cart item
        this.cart.push(item);
      } else {
        // update existing cart item
        this.cart[index] = item;
      }
    } else {
      // delete cart item
      this.cart = this.cart.filter((obj) => obj.id !== item.id);
    }

    this.total = this.getTotalAmount();
    this.displayTotalAmount();

    // do this only when navigating to next step
    this.createSummaryTable();
    this.writeCartToOrderField();
  };

  getTotalAmount = () => {
    const propertyValues = this.cart.map((item) => parseFloat(item.total));
    console.log(propertyValues);
    const summary = propertyValues.length
      ? propertyValues.reduce((acc, val) => acc + val)
      : 0;
    return summary;
  };

  displayTotalAmount = () => {
    if (this.total > 0) {
      this.$totalAmount.text(`${this.total.toFixed(2)} ${this.currency}`);
      this.$nextButton.removeClass("d-none");
    } else {
      this.$totalAmount.text("");
      this.$nextButton.addClass("d-none");
    }
  };

  // render
  createSummaryTable = () => {
    this.$summaryTable.empty();

    // create a header row with column names
    var headerRow = this.$summaryTable[0].insertRow();
    for (var i in this.th) {
      var headerCell = document.createElement("th"); // create th element
      headerCell.textContent = this.th[i];
      headerRow.appendChild(headerCell);
    }

    for (var i = 0; i < this.cart.length; i++) {
      const item = this.cart[i];
      var row = this.$summaryTable[0].insertRow();
      var cell1 = row.insertCell();
      cell1.textContent = `${item.amount} x ${item.packageSize}`;

      var cell2 = row.insertCell();
      cell2.textContent = item.name;

      var cell3 = row.insertCell();
      cell3.textContent = `${item.total} ${item.currency}`;

      row.appendChild(cell1);
      row.appendChild(cell2);
      row.appendChild(cell3);
    }
  };

  nextStepHandler = () => {
    this.$step1.addClass("d-none");
    this.$step2.removeClass("d-none");
  };

  prevStepHandler = () => {
    this.$step2.addClass("d-none");
    this.$step1.removeClass("d-none");
  };

  writeCartToOrderField = () => {
    // write cart into the order field (textarea) as human readable
    let order = "";
    for (var i = 0; i < this.cart.length; i++) {
      const item = this.cart[i];
      order += `${item.amount} x ${item.packageSize} ${item.name} ${item.total} ${item.currency}`;
      // add line break except for last item
      if (i < this.cart.length - 1){
        order += "\r\n";
      }
    }
    this.$orderField.val(order);

    // write total amount into the amount field
    this.$amountField.val(`${this.total.toFixed(2)} ${this.currency}`);

  };

  formSubmitHandler = (e) => {
    e.preventDefault();

    const form = e.target;

    const data = new FormData(form);
    let request = new XMLHttpRequest();

    console.log("form", form);

    if (this.safari) {
      for (var i = 0; i < form.elements.length; i++) {
        if (form.elements[i].type == "file") {
          if (form.elements[i].value == "") {
            var elem = form.elements[i];
            data.delete(elem.name);
          }
        }
      }
    }

    const method = form.getAttribute("method");
    const action = form.getAttribute("action");

    request.open(method, action ? action : window.location.href, true);
    request.setRequestHeader("Cache-Control", "no-cache");
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");
    request.setRequestHeader("Accept", "application/json");

    this.lockSubmit();

    request.onload = () => {
      if (request.status === 200) {
        const response = JSON.parse(request.response);

        console.log("response", response);

        if (response.success) {
          this.handleSuccess();
        } else if (response.errors) {
          console.log("error");
        }
      } else {
        console.error(request);
      }
      this.unlockSubmit();
    };

    request.send(data);
  };

  lockSubmit = () => {
    this.$formSubmit.prop("disabled", true);
  };

  unlockSubmit = () => {
    this.$formSubmit.prop("disabled", false);
  };

  handleSuccess = () => {
    // ajax request
    $.ajax({
      url: this.$form.data("success-url"),
      type: "GET",
      success: (data, textStatus, jqXHR) => {
        this.$formContainer.html(data);
      },
    });
  };
}

export default Shop;
